import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';
import * as systemActionTypes from '../../system/action-creator/actionTypes';

const email = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_CREDENTIALS:
      return action.email;
    case systemActionTypes.RESET_PASSWORD_SUCCESS:
      return "";
    default:
      return state;
  }
}

const otp = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_CREDENTIALS:
      return action.otp;
    case systemActionTypes.RESET_PASSWORD_SUCCESS:
      return "";
    default:
      return state;
  }
}

const password = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_PASSWORD:
      return action.password;
    case systemActionTypes.RESET_PASSWORD_SUCCESS:
      return "";
    default:
      return state;
  }
}

const passwordError = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_PASSWORD:
      return action.error;
    default:
      return state;
  }
}

const confirmPassword = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_CONFIRM_PASSWORD:
      return action.password;
    case systemActionTypes.RESET_PASSWORD_SUCCESS:
      return "";
    default:
      return state;
  }
}

const confirmPasswordError = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_CONFIRM_PASSWORD:
    case actionTypes.SET_CONFIRM_PASSWORD_ERROR:
      return action.error;
    default:
      return state;
  }
}

const alertMessage = (state = "", action) => {
  switch (action.type) {
    case systemActionTypes.RESET_PASSWORD_FAILURE:
    case systemActionTypes.RESET_PASSWORD_SUCCESS:
    case actionTypes.SET_ALERT_MESSAGE:
      return action.message;
    default:
      return state;
  }
}

const openDialog = (state = false, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_ALIERT_DIALOG:
      return !state;
    case systemActionTypes.RESET_PASSWORD_FAILURE:
    case systemActionTypes.RESET_PASSWORD_SUCCESS:
    case actionTypes.SET_ALERT_MESSAGE:
      return true;
    default:
      return state;
  }
}

const isResetSuccess = (state = false, action) => {
  switch (action.type) {
    case systemActionTypes.RESET_PASSWORD_SUCCESS:
      return true;
    default:
      return state;
  }
}

export default combineReducers({
  email,
  otp,
  password,
  passwordError,
  confirmPassword,
  confirmPasswordError,
  alertMessage,
  openDialog,
  isResetSuccess
});

const getCurrentState = state => state.resetPassword;

export const getEmail = state => getCurrentState(state).email;

export const getOTP = state => getCurrentState(state).otp;

export const getPassword = state => getCurrentState(state).password;

export const getPasswordError = state => getCurrentState(state).passwordError;

export const getConfirmPassword = state => getCurrentState(state).confirmPassword;

export const getConfirmPasswordError = state => getCurrentState(state).confirmPasswordError;

export const getAlertMessage = state => getCurrentState(state).alertMessage;

export const getOpenDialog = state => getCurrentState(state).openDialog;

export const getIsResetSuccess = state => getCurrentState(state).isResetSuccess;

export const getIsValid = state => {
  const { email, password, confirmPassword, otp, } = getCurrentState(state);

  let validPassword = true;
  if (password.search(/[A-Z][0-9][!@#$%^&*()_+]/) < 0) {
    validPassword = false;
  }
  // return email && password && confirmPassword && otp && (password === confirmPassword) && validPassword;
}